import { render, staticRenderFns } from "./logistics_tool.vue?vue&type=template&id=280d838d&scoped=true"
import script from "./logistics_tool.vue?vue&type=script&lang=js"
export * from "./logistics_tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d838d",
  null
  
)

export default component.exports